import React from 'react';
import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import fileAddOutline from '@iconify/icons-eva/plus-square-fill';


const getIcon = (name: any) => <Icon icon={name} width={22} height={22} />;

const sidebarConfigAdmin = [
    {
        title: 'dashboard',
        icon: getIcon(pieChart2Fill),
        path: '/admin/dashboard',
        isProduction: true,
        showInRegister: false
    },
    {
        title: 'adminOrdersClient',
        icon: getIcon(fileAddOutline),
        path: '/admin/orders/list',
        isProduction: true,
        showInRegister: false
    },
    {
        title: 'adminUsers',
        icon: getIcon(fileAddOutline),
        path: '/admin/clients/list',
        isProduction: true,
        showInRegister: false
    },
];

export default sidebarConfigAdmin;
